<template>
    <div @mousedown="onMouseDown" @mousemove="onMouseMove" @click="go_to($event)" class="card carousel-card" @mouseover="hover = true" @mouseleave="hover = false" :class="{ 'hover-card': hover, 'regular-card': !hover }">
        <div class="card-body rounded-3" >
            <h5 class="card-title">{{ title }}</h5>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const router = useRouter()

const props = defineProps({
  to: {
    type: [Object, String],
    required: true
  },
  title: {
    type: String,
    default: ''
  },
})

const isDragging = ref(false)

const onMouseDown = () => {
  console.log('mousedown set dragging false')
  isDragging.value = false
}

const onMouseMove = () => {
  console.log('mousemove set dragging true')
  isDragging.value = true
}

function go_to() {
  if (isDragging.value) {
    event.preventDefault()
    event.stopPropagation()
    return
  }
	router.push(props.to)
}

const hover = ref(false)
</script>
<style lang="css" scoped>

h1,
h2 {
  font-weight: normal;
}
.progress-bar {
    background: #aaf;
}
.carousel__slide {
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.progress,.progress + small{
  z-index: 9;
  left:10px;
}
.carousel-card {
  height: 115px;
  width: 200px;
}
.carousel-card .card-body {
  height: 115px;
  width: 200px;
  background-size: cover;
  background-position: center;
  position: relative;
}

h5.card-title {
  font-size: 16px;
  color: #ffffff !important;
  padding: 5px;
  text-shadow: 0px 0px 5px rgba(0, 0, 0, 1);
  width: 100%;
  text-align: center;
  -webkit-text-stroke: 3px black;
  paint-order: stroke fill;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.hover-card {
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #ddf;
}
.regular-card {
  background-color: #f8f8ff;
}

</style>
